import { useContext } from "react";
import profileContext from "../providers/Profile/ProfileContext";


function useProfile() {
    return useContext(profileContext);
}

export default useProfile